export default "__VITE_ASSET__Dimi0vqq__"